import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ onTakeSurvey }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.headContainer}>
          <div className={styles.headShadow} />
          <div className={styles.bottomShadow} />
          <img
            className={styles.headBg}
            src={getImageFromS3('images/sms-prl-line/head-bg.gif')}
            alt="head-bg"
          />
        </div>
        <img
          className={styles.logo}
          src={getImageFromS3('images/sms-prl-line/logo.png')}
          alt="logo"
        />
        <img
          className={styles.packs}
          src={getImageFromS3('images/sms-prl-line/packs.png')}
          alt="packs"
        />
        <div className={styles.characteristicContainer}>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-prl-line/tobacco.png')}
              alt="tobacco"
            />
            <p><span>Абсолютно нова</span><br /> високоякісна тютюнова<br /> суміш від Parliament</p>
          </div>
          <div className={styles.filterContainer}>
            <div className={styles.filterText}>
              <p className={styles.filterTitle}><b>Оригінальний<br /> Recessed™</b> фільтр</p>
              <p className={styles.filterDescription}>з ущільненою<br />повітряною камерою<br />та вугільною<br />частиною</p>
            </div>
            <img
              src="/images/filter.png"
              alt="filter"
            />
            <img
              className={styles.gifFilter}
              src="/images/filter.gif"
              alt="filter-gif"
            />
          </div>
          <div className={styles.formatContainer}>
            <div className={styles.formatText}>
              <p className={styles.formatTitle}>Формат</p>
              <p className={styles.formatDescription}>King Size Super<br />Slim ("Кінг сайз<br />супер слім")</p>
            </div>
            <img
              src={getImageFromS3('images/sms-prl-line/format.png')}
              alt="format"
            />
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.buyTitle}>Хочеш отримувати новини про продукцію?</p>
          <p className={styles.buyDescription}>Проходь невелике опитування та отримуй <b>30 грн</b> на мобільний за витрачений час.</p>
          <div className={styles.buttonContainer}>
            <div className={styles.buttonItem} onClick={onTakeSurvey}>
              <img
                src={getImageFromS3('images/sms-prl-line/survey-glass.png')}
                alt="survey-glass"
              />
              <p>Пройти опитування</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація про<br />
        продукт надається<br />відповідно<br />до статті 15 Закону<br />України «Про захист<br />
        прав споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
